(() => {
  if (customElements.get('hh-pdp-manufacturer-route')) return;
  class HhPdpManufacturerRoute extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.intersecting = false;
      this.userPaused = this.userPaused || false;
      this.toggle = this.closest('.hh-pdp-manufacturer')?.querySelector('[data-hh-mfr-toggle]') || null;
      this.toggleLabel = this.toggle?.querySelector('[data-hh-mfr-toggle-label]');
      this.motion.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.toggle?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.sync();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this.intersecting = entries[entries.length - 1].isIntersecting;
          this.sync();
        }, { threshold: 0.3 });
        this.observer.observe(this);
      } else {
        this.intersecting = true;
      }
      this.sync();
    }
    sync() {
      const reduced = this.motion.matches;
      if (this.toggle) {
        this.toggle.hidden = reduced;
        this.toggle.disabled = reduced;
        this.toggle.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
        const label = this.userPaused ? this.toggle.dataset.play : this.toggle.dataset.pause;
        if (this.toggleLabel && label) this.toggleLabel.textContent = label;
      }
      if (reduced) {
        this.setAttribute('data-animate', 'static');
        return;
      }
      const running = this.intersecting && !this.userPaused && !document.hidden;
      this.setAttribute('data-animate', running ? 'run' : 'paused');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      this.observer = null;
    }
  }
  customElements.define('hh-pdp-manufacturer-route', HhPdpManufacturerRoute);
})();
